import axios from "axios";
import Echo from "laravel-echo";
import Pusher from "pusher-js";

let echo;

if (typeof window !== "undefined") {
  window.Pusher = Pusher;
  echo = new Echo({
    broadcaster: "pusher",
    key: process.env.NEXT_PUBLIC_PUSHER_KEY,
    cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,

    authorizer: (channel) => {
      return {
        authorize: (socketId, callback) => {
          const options = {
            headers: { "Content-Type": "application/json" },
            withXSRFToken: true,
            withCredentials: true,
          };
          const data = {
            socket_id: socketId,
            channel_name: channel.name,
          };
          axios
            .post(
              `${process.env.NEXT_PUBLIC_COMMON_BASE_URL}/broadcasting/auth`,
              data,
              options
            )
            .then((response) => {
              callback(false, response.data);
            })
            .catch((error) => {
              callback(true, error);
            });
        },
      };
    },

    forceTLS: true,
  });
}

export default echo;
